module.exports = __webpack_public_path__ + "static/ELCO_Scroll_Beta_Mobile_SM_02-d7a1e10cf784e4278da9191835878f0d.mp4";